module.exports = __webpack_public_path__ + "static/img/index-sys4.0c00c5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/index-sys4.svg
// module id = A5lY
// module chunks = 11